import styled from "styled-components";

const ErrorText = styled.span`
    color: ${props => props.theme.colours.flat.rose.hex};
    font-size: ${props => props.theme.text.subText.sizeRem};
`;

export default ErrorText;
